import React from "react";
import { Container, Row, Col, Form, FormControl, Button, Card } from "react-bootstrap";
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import 'assets/css/dataTable.css';

const ContainerRangosFolios = ({
  empresaOptions,
  companyLoading,
  tipoDocumentoOptions,
  deviceOptions,
  deviceLoading,
  empresa,
  setEmpresa,
  tipoDocumento,
  setTipoDocumento,
  device,
  setDevice,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  folioIni,
  setFolioIni,
  folioFin,
  setFolioFin,
  handleSearch,
  searching,
  searchError,
  responseData,
  columns,
  paginationOpciones,
  actionsMemo,
}) => {
  const isOnlyDigits = (value) => /^\d*$/.test(value);

  return (
    <Container fluid className="page-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">Rango de Folios</h2>
          <p className="page-subtitle">
            Consulta los rangos de folios asignados a una empresa por tipo de documento, dispositivo y fecha.
          </p>
        </div>
      </div>

      <Card className="data-card">
        <Card.Body>
          <Form onSubmit={handleSearch} className="filter-form">
            <Row>
              <Col sm={12} md={6} lg={4}>
                <Form.Group className="form-field">
                  <Form.Label>Empresa</Form.Label>
                  <Select
                    options={empresaOptions}
                    value={empresaOptions.find((o) => o.value === empresa) || null}
                    onChange={(opt) => setEmpresa(opt ? opt.value : '')}
                    placeholder="Selecciona una empresa..."
                    isLoading={companyLoading}
                    classNamePrefix="rs"
                  />
                </Form.Group>
              </Col>
              <Col sm={12} md={6} lg={3}>
                <Form.Group className="form-field">
                  <Form.Label>Tipo documento</Form.Label>
                  <Select
                    options={tipoDocumentoOptions}
                    value={tipoDocumentoOptions.find((o) => o.value === tipoDocumento) || tipoDocumentoOptions[0]}
                    onChange={(opt) => setTipoDocumento(opt.value)}
                    classNamePrefix="rs"
                  />
                </Form.Group>
              </Col>
              <Col sm={12} md={6} lg={3}>
                <Form.Group className="form-field">
                  <Form.Label>Cajero</Form.Label>
                  <Select
                    options={deviceOptions}
                    value={deviceOptions.find((o) => o.value === device) || null}
                    onChange={(opt) => setDevice(opt ? opt.value : '')}
                    placeholder="Todos"
                    isLoading={deviceLoading}
                    isDisabled={!empresa || deviceLoading}
                    classNamePrefix="rs"
                  />
                </Form.Group>
              </Col>
              <Col sm={6} md={3} lg={2}>
                <Form.Group className="form-field">
                  <Form.Label>Folio inicial</Form.Label>
                  <FormControl
                    type="text"
                    inputMode="numeric"
                    value={folioIni}
                    onChange={(e) => {
                      if (isOnlyDigits(e.target.value)) setFolioIni(e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={6} md={3} lg={2}>
                <Form.Group className="form-field">
                  <Form.Label>Folio fin</Form.Label>
                  <FormControl
                    type="text"
                    inputMode="numeric"
                    value={folioFin}
                    onChange={(e) => {
                      if (isOnlyDigits(e.target.value)) setFolioFin(e.target.value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={6} md={3} lg={3}>
                <Form.Group className="form-field">
                  <Form.Label>Desde</Form.Label>
                  <FormControl
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col sm={6} md={3} lg={3}>
                <Form.Group className="form-field">
                  <Form.Label>Hasta</Form.Label>
                  <FormControl
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col sm={12} lg={3} className="d-flex align-items-end form-actions">
                <Button type="submit" className="btn-primary-action" disabled={searching}>
                  <i className="nc-icon nc-zoom-split" />
                  {searching ? 'Buscando...' : 'Buscar'}
                </Button>
              </Col>
            </Row>
            {searchError && (
              <div className="filter-form__error">{searchError}</div>
            )}
          </Form>
        </Card.Body>
      </Card>

      {responseData && (
        <Card className="data-card">
          <Card.Body>
            <div className="data-card__toolbar">
              <span className="toolbar-meta">
                {responseData.length} resultado{responseData.length === 1 ? '' : 's'}
              </span>
              <Button className="btn-export" onClick={actionsMemo.onExport}>
                <i className="nc-icon nc-cloud-download-93" />
                Exportar CSV
              </Button>
            </div>
            <DataTable
              className="-striped -highlight"
              fixedHeader={true}
              noDataComponent="No hay folios asignados en el rango seleccionado"
              columns={columns}
              data={responseData}
              pagination
              paginationComponentOptions={paginationOpciones}
            />
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default ContainerRangosFolios;
